let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("VT3E8")).then(() => parcelRequire('krOoz'));